import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

const PanelTitle = styled.h2`
  color: #2D3653;
  text-align: center;
  font-family: 'Style Script', cursive;
  font-size: clamp(16px, 1.5vw, 24px);
  margin-bottom: 10px;
  margin-top: 10px;

  @media (max-width: 768px) {
    margin-bottom: 0;
  }
`;

const ScrollContainer = styled.div`
  height: 180px;
  overflow: hidden;
  position: relative;

  @media (max-width: 768px) {
    height: 120px;
    overflow: hidden;
    position: relative;
  }
`;

const ScrollContent = styled.div`
  animation: ${({ $autoScroll }) => ($autoScroll ? "scroll 30s linear infinite" : "none")};
  @keyframes scroll {
    0% {
      transform: translateY(0);
    }
    100% {
      transform: translateY(-50%);
    }
  }
  &:hover {
    animation-play-state: paused;
  }
`;

const RdvItem = styled.div`
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 10px;
  padding: 4px 0;
  border-bottom: 1px solid rgba(45, 54, 83, 0.1);
  
  &:last-child {
    border-bottom: none;
  }
`;

const RdvLabel = styled.div`
  color: #2D3653;
  font-family: 'IBM Plex Sans JP', sans-serif;
  font-size: 13px;
`;

const RdvDate = styled.div`
  color: #2D3653;
  font-family: 'IBM Plex Sans Hebrew', sans-serif;
  text-align: right;
  font-size: 13px;
`;

const RdvContainer = ({ nextEvents, gridArea, autoScroll = true }) => {
  const { t, i18n } = useTranslation();
  const formatEventDate = (dateStr) => {
    const [month, day, year] = dateStr.split('/');
    const date = new Date(year, month - 1, day);
    
    return date.toLocaleDateString(i18n.language, {
      day: 'numeric',
      month: 'long',
      year: 'numeric'
    });
  };

  return (
    <>
      <PanelTitle>{t('display.nextAppointment')}</PanelTitle>
      <ScrollContainer>
        <ScrollContent $autoScroll={autoScroll}>
          {nextEvents?.events.map((event, index) => (
            <RdvItem key={index}>
              <RdvLabel>
                {event.description}
              </RdvLabel>
              <RdvDate>
                {formatEventDate(event.gregorianDate)}
                {" - "}
                {event.hebrewDate}
              </RdvDate>
            </RdvItem>
          ))}
        </ScrollContent>
      </ScrollContainer>
      </>
  );
};

export default RdvContainer; 